
import { Mappeable } from './mappeable.model';
import * as _ from 'lodash';

export class BusinessUnit extends Mappeable {

    idBusinessUnitPk: number;
    txtoUnitBusiness: string;
    mrkActive: boolean;

    constructor(o) {
        super(o);
        this.mrkActive = this.mrkActive ??  false 
    }

    public mapToBack() {
        return {
            txtoUnitBusiness: this.txtoUnitBusiness,
            mrkActive: this.mrkActive
        }
    }


}
